/* @flow */
import { call, put, takeLatest } from 'redux-saga/effects';
import { callGetPendingUsers, callVerifyUser, callRejectUser } from 'api/verification';
import VerificationActions from 'data/verification/actions';
import PaginationActions from 'data/pagination/actions';
import { PAGE_SIZE } from 'data/pagination/config';

export function* getPendingUsers(action: {
  page: number,
  sort: string,
  desc: boolean,
  search?: string,
}): Generator<Object, void, void> {
  try {
    yield put({ type: 'GET_PENDING_USERS_REQUEST' });
    const response: Object = yield call(
      callGetPendingUsers,
      PAGE_SIZE,
      action.page,
      action.sort,
      action.desc,
      action.search,
    );
    yield put(VerificationActions.putPendingUsers(response.data));
    yield put(
      PaginationActions.setPage(
        'pendingVerification',
        action.page,
        response.headers.count,
        response.data.map(u => u._id),
      ),
    );
    yield put({ type: 'GET_PENDING_USERS_SUCCESS' });
  } catch (error) {
    yield put({
      type: 'GET_PENDING_USERS_FAILURE',
      error: error.message,
    });
  }
}

export function* verifyUser(action: {
  id: string,
}): Generator<Object, void, void> {
  try {
    yield put({ type: 'VERIFY_USER_REQUEST' });
    yield call(callVerifyUser, action.id);
    yield put(VerificationActions.removePendingUser(action.id));
    yield put(PaginationActions.takeFrom(action.id, 'pendingVerification'));
    yield put({ type: 'VERIFY_USER_SUCCESS' });
  } catch (error) {
    yield put({
      type: 'VERIFY_USER_FAILURE',
      error: error.message,
    });
  }
}

export function* rejectUser(action: {
  id: string,
}): Generator<Object, void, void> {
  try {
    yield put({ type: 'REJECT_USER_REQUEST' });
    yield call(callRejectUser, action.id);
    yield put(VerificationActions.removePendingUser(action.id));
    yield put(PaginationActions.takeFrom(action.id, 'pendingVerification'));
    yield put({ type: 'REJECT_USER_SUCCESS' });
  } catch (error) {
    yield put({
      type: 'REJECT_USER_FAILURE',
      error: error.message,
    });
  }
}

const verificationSaga = [
  takeLatest('GET_PENDING_USERS', getPendingUsers),
  takeLatest('VERIFY_USER', verifyUser),
  takeLatest('REJECT_USER', rejectUser),
];

export default verificationSaga;
